import styled from "@emotion/styled";
import Loader from "react-loader-spinner";

const NewSoloRegistrationWrapper = styled.div`
  h3 {
    span {
      border-bottom: 1px solid yellowgreen;
    }
  }
`;

function NewSoloRegistration({
  tournamentName,
  registering,
  onClick,
  closeModal,
  showThankYou,
}: {
  tournamentName: string;
  registering: boolean;
  onClick: Function;
  closeModal: Function;
  showThankYou: boolean;
}) {
  return (
    <NewSoloRegistrationWrapper>
      {!registering && !showThankYou && (
        <h3>
          Registering you for <span>{tournamentName}</span>
        </h3>
      )}
      {!registering && showThankYou && (
        <h3 style={{ margin: "auto", textAlign: "center" }}>
          Thank you for registering!
        </h3>
      )}
      {!registering && showThankYou && (
        <button
          className="btn"
          disabled={registering}
          onClick={() => closeModal()}
        >
          Close
        </button>
      )}
      {!registering && !showThankYou && (
        <button
          className="btn"
          disabled={registering}
          onClick={() => onClick()}
        >
          {!registering && !showThankYou && "Okay!"}
          {registering && (
            <Loader type="Bars" color="#fff" height={26} width={50} />
          )}
        </button>
      )}
    </NewSoloRegistrationWrapper>
  );
}

export default NewSoloRegistration;
